import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbaniaonrentinpune() {



const cardData =
  {
    keyword: 'Force Urbania On Rent in Pune',
    heading: 'Sanavi Travels: Force Urbania On Rent in Pune',
    headingDescription: 'Sanavi Travels offers premium and reliable **Force Urbania On Rent in Pune** for family trips, corporate travel, weddings, airport transfers, sightseeing tours, and outstation journeys. Force Urbania is a modern luxury passenger vehicle designed to provide superior comfort, spacious interiors, advanced safety features, and a smooth travel experience for groups. Available in multiple seating options including 9 Seater, 13 Seater, 15 Seater, 16 Seater, and 17 Seater variants, our Force Urbania rental service is ideal for large families, corporate teams, wedding guests, tourists, pilgrims, and event travelers. With comfortable push-back seats, ample legroom, powerful air conditioning, wide windows, and generous luggage space, Force Urbania ensures a relaxing journey even on long-distance routes. Sanavi Travels provides well-maintained, fully insured, and regularly sanitized Urbania vehicles operated by professional drivers who are experienced with Pune city routes, highways, and popular tourist destinations across Maharashtra, Goa, Karnataka, and Gujarat. Whether you need a **Force Urbania Rental in Pune** for a Pune to Mumbai trip, Shirdi tour, Mahabaleshwar vacation, corporate event, airport pickup, or wedding transportation, we offer affordable pricing, flexible packages, punctual service, and 24/7 customer support. Our commitment to safety, comfort, and customer satisfaction makes Sanavi Travels a trusted choice for luxury group transportation and Force Urbania Hire in Pune.',

    top: 'Popular Travel Uses for Force Urbania On Rent in Pune',


"topPlaces": [
  {
    "title": "Force Urbania for Airport Transfers in Pune",
    "description": "Force Urbania is an excellent option for Pune airport transfers when traveling in groups. Its spacious luggage area, comfortable high-back seats, and smooth suspension ensure stress-free airport pickups and drops. Corporate teams, large families, and wedding groups prefer Urbania for airport travel due to its punctuality, comfort, and ability to accommodate both passengers and luggage without congestion. Even during early morning or late-night flights, Urbania ensures safe, reliable, and relaxed travel."
  },
  {
    "title": "Force Urbania for Wedding Transportation",
    "description": "Urbania is widely used for wedding transportation in Pune to move guests, relatives, and family members between venues, hotels, and homes. Its luxury interiors, elegant appearance, and comfortable seating make it suitable for premium wedding travel. Wedding planners prefer Urbania for coordinated group movement, ensuring guests arrive together, on time, and in comfort during ceremonies, receptions, and destination weddings."
  },
  {
    "title": "Corporate Travel and Employee Transport",
    "description": "Corporate organizations frequently hire Force Urbania for employee transportation, conferences, seminars, plant visits, team outings, and corporate events. The quiet cabin, spacious interiors, and professional appearance make Urbania ideal for corporate group travel across Pune, MIDC areas, and business hubs."
  },
  {
    "title": "Local Sightseeing in Pune",
    "description": "Tourists and large families prefer Force Urbania for local sightseeing in Pune as it offers comfort throughout the day, even with multiple stops and traffic conditions. Urbania allows groups to travel together conveniently while exploring city attractions, temples, historical places, shopping areas, and nearby tourist spots."
  },
  {
    "title": "Outstation Tours from Pune",
    "description": "Force Urbania is perfect for outstation travel from Pune to destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Kolhapur, Goa, and other long-distance tourist locations. Its powerful engine, highway stability, and comfortable seating make long journeys fatigue-free for all passengers."
  },
  {
    "title": "Family Vacations and Group Trips",
    "description": "Urbania is an ideal choice for family vacations and group trips where comfort, safety, and space are priorities. With ample legroom and luggage capacity, it ensures relaxed travel for elders, children, and adults over long durations."
  },
  {
    "title": "School and College Trips",
    "description": "Educational institutions often hire Force Urbania for school and college trips due to its safety features, seating capacity, and comfort. It is suitable for excursions, educational tours, and student travel."
  },
  {
    "title": "Religious Tours and Pilgrimages",
    "description": "Urbania is commonly used for religious tours and pilgrimages from Pune, offering comfortable group travel for temples and spiritual destinations across Maharashtra."
  },
  {
    "title": "Event and Party Transportation",
    "description": "For events, parties, and social gatherings, Force Urbania provides convenient group transportation, reducing the need for multiple vehicles and ensuring everyone travels together safely."
  },
  {
    "title": "Multi-Day Group Travel Packages",
    "description": "Urbania is ideal for multi-day group tours, offering consistent comfort, storage space, and reliability throughout extended travel itineraries."
  }
]
,



"services": [
{
"name": "Force Urbania On Rent in Pune",
"description": "Force Urbania On Rent in Pune offers a premium group travel solution for families, corporate teams, tourists, and event organizers. With spacious seating, luxury interiors, advanced safety features, and smooth ride quality, Urbania is suitable for airport transfers, weddings, corporate events, sightseeing, and long-distance tours. Sanavi Travels ensures clean vehicles, professional drivers, transparent pricing, and dependable service."
},
{
"name": "Urbania Cab Hire Pune",
"description": "Urbania Cab Hire Pune provides flexible rental options for local, outstation, and event-based travel. This service is ideal for customers who require spacious, luxurious, and reliable group transportation with professional chauffeur support."
},
{
"name": "9 Seater Urbania On Rent Pune",
"description": "9 Seater Urbania On Rent Pune is suitable for small groups seeking premium comfort and ample luggage space while traveling within Pune or nearby destinations."
},
{
"name": "13 Seater Urbania On Rent Pune",
"description": "13 Seater Urbania On Rent Pune offers balanced capacity and comfort, making it ideal for family outings, corporate teams, and airport transfers."
},
{
"name": "15 Seater Urbania On Rent Pune",
"description": "15 Seater Urbania On Rent Pune is perfect for medium-sized groups, offering spacious seating, smooth suspension, and comfortable long-distance travel."
},
{
"name": "16 Seater Urbania On Rent Pune",
"description": "16 Seater Urbania On Rent Pune is widely used for wedding guests, corporate travel, and sightseeing tours due to its capacity and premium comfort."
},
{
"name": "17 Seater Urbania On Rent Pune",
"description": "17 Seater Urbania On Rent Pune is ideal for large groups, ensuring everyone travels together comfortably without compromising safety or space."
},
{
"name": "Luxury Force Urbania On Rent Pune",
"description": "Luxury Force Urbania On Rent Pune delivers a high-end travel experience with premium interiors, AC comfort, and professional chauffeurs for special occasions."
},
{
"name": "Urbania Hire for Airport Transfer Pune",
"description": "Urbania Hire for Airport Transfer Pune ensures timely pickups, ample luggage capacity, and smooth group transportation for airport travel."
},
{
"name": "Urbania Hire for Wedding Pune",
"description": "Urbania Hire for Wedding Pune provides elegant and reliable transportation for wedding guests and families across venues."
},
{
"name": "Urbania Hire for Corporate Travel Pune",
"description": "Urbania Hire for Corporate Travel Pune supports business travel, conferences, and employee movement with comfort and professionalism."
},
{
"name": "Urbania Hire for Local Sightseeing Pune",
"description": "Urbania Hire for Local Sightseeing Pune allows groups to explore Pune together comfortably throughout the day."
},
{
"name": "Affordable Urbania Rental Pune",
"description": "Affordable Urbania Rental Pune offers premium group travel at competitive pricing without compromising on service quality."
},
{
"name": "Best Urbania Hire Service Pune",
"description": "Best Urbania Hire Service Pune by Sanavi Travels is trusted for reliability, luxury vehicles, experienced drivers, and customer satisfaction."
},
{
"name": "Urbania On Rent with Driver Pune",
"description": "Urbania On Rent with Driver Pune includes trained chauffeurs who manage routes, traffic, and schedules for a relaxed journey."
}
],
"tableData": [
["Force Urbania On Rent in Pune", "Urbania Cab Hire Pune"],
["9 Seater Urbania Pune", "13 Seater Urbania Pune"],
["15 Seater Urbania Pune", "16 Seater Urbania Pune"],
["17 Seater Urbania Pune", "Luxury Urbania Pune"],
["Urbania Airport Transfer Pune", "Urbania Wedding Hire Pune"],
["Urbania Corporate Hire Pune", "Urbania Sightseeing Pune"],
["Affordable Urbania Pune", "Urbania with Driver Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Force Urbania On Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers premium, safe, and comfortable Force Urbania rental services across Pune."
  },
  {
    "WhyChooseheading": "Luxury and Spacious Interiors",
    "WhyChoosedescription": "Force Urbania provides exceptional space, legroom, and comfort for group travel."
  },
  {
    "WhyChooseheading": "Multiple Seating Options",
    "WhyChoosedescription": "Available in 9, 13, 15, 16, and 17 seater variants to match group size."
  },
  {
    "WhyChooseheading": "Experienced Professional Drivers",
    "WhyChoosedescription": "Skilled chauffeurs ensure safe driving, punctual service, and smooth journeys."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges ensures peace of mind."
  },
  {
    "WhyChooseheading": "Suitable for All Occasions",
    "WhyChoosedescription": "Ideal for airport transfers, weddings, corporate travel, sightseeing, and tours."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Vehicles",
    "WhyChoosedescription": "Urbania vehicles are cleaned and sanitized before every trip."
  },
  {
    "WhyChooseheading": "24/7 Booking Support",
    "WhyChoosedescription": "Round-the-clock assistance for bookings and travel coordination."
  }
]

}

const faqData = [
  {
    question: 'Do you provide Force Urbania on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers Force Urbania on rent in Pune for group travel.'
  },
  {
    question: 'What seating capacities are available in Urbania?',
    answer: 'Urbania is available in 9, 13, 15, 16, and 17 seater options.'
  },
  {
    question: 'Is Urbania suitable for long-distance travel?',
    answer: 'Yes, Urbania is ideal for outstation and long-distance group travel.'
  },
  {
    question: 'Is driver included in Urbania booking?',
    answer: 'Yes, all Urbania rentals include experienced drivers.'
  },
  {
    question: 'Is Urbania suitable for weddings and corporate events?',
    answer: 'Yes, Urbania is widely used for weddings, corporate travel, and events.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshpande',
    feedback: 'Hired Force Urbania for a corporate event in Pune. Excellent comfort and professional service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Kavita Joshi',
    feedback: 'Booked Urbania for a family wedding. Spacious, clean, and very comfortable.',
    rating: 5
  }
];





























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/force-urbania-on-rent-in-pune#service",

  "name": "Force Urbania On Rent in Pune",

  "serviceType": "Force Urbania Rental",

  "description":
    "Sanavi Travels offers Force Urbania on rent in Pune for family trips, corporate travel, weddings, airport transfers, group tours, events and outstation journeys with a professional driver.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/force-urbania-on-rent-in-pune"
};












  return (
    <div>


<Helmet>
  <title>
    Force Urbania On Rent in Pune | Urbania Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Force Urbania on rent in Pune with Sanavi Travels for family trips, corporate travel, weddings, airport transfers, group tours and outstation journeys with a professional driver."
  />

  <meta
    name="keywords"
    content="Force Urbania On Rent in Pune, Force Urbania Rental Pune, Urbania Hire Pune, Force Urbania Pune, Urbania Van Rental Pune, Urbania for Wedding Pune, Urbania for Outstation Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/Force-Urbania-On-Rent-in-Pune"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Force Urbania On Rent in Pune | Urbania Rental | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Rent a Force Urbania in Pune for family trips, corporate travel, weddings, airport transfers, group tours and outstation journeys with a professional driver."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/Force-Urbania-On-Rent-in-Pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/force-urbania-on-rent-in-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/force-urbania-on-rent-in-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forceurbaniaonrentinpune;